import manifest from '@/assets/image/worldcup2026/manifest.json'

const flagContext = require.context('@/assets/image/worldcup2026/team-flags', false, /\.png$/)
const localFlagMap = {}

;(manifest.categories['team-flags'] || []).forEach(item => {
  localFlagMap[item.team_code] = flagContext('./' + item.file)
})

function codeFromUrl (url) {
  if (!url) return ''
  const match = String(url).match(/worldcup2026\/([A-Z]\d+)\.png/i)
  return match ? match[1].toUpperCase() : ''
}

export function resolveTeamLogo (url) {
  if (url && /^https:\/\//.test(url)) return url
  const code = codeFromUrl(url)
  return code && localFlagMap[code] ? localFlagMap[code] : ''
}

export function placeholderText (name) {
  if (!name) return ''
  if (name.indexOf('第') === 0) return '第'
  return String(name).slice(0, 1).toUpperCase()
}
